import { useContext, useEffect, useRef } from 'react';
import VideoContext from '../context/VideoContext';

const useClickOutside = (handler) => {
    const domNode = useRef(null);

    useEffect(() => {
        const maybeHandler = (event) => {
            if (domNode.current && !domNode.current.contains(event.target)) {
                handler();
            }
        };

        document.addEventListener('mousedown', maybeHandler);
        return () => {
            document.removeEventListener('mousedown', maybeHandler);
        };
    }, [handler]);

    return domNode;
};

const VideoPopup = () => {
    const { video, hideVideo } = useContext(VideoContext);
    const domNode = useClickOutside(hideVideo);

    if (!video.show) {
        return null;
    }

    return (
        <>
            <div className="mfp-bg mfp-ready" onClick={hideVideo} />
            <div className="mfp-wrap mfp-close-btn-in mfp-auto-cursor mfp-ready" tabIndex={-1}>
                <div className="mfp-container mfp-s-ready mfp-iframe-holder">
                    <div className="mfp-content" ref={domNode}>
                        <div className="mfp-iframe-scaler">
                            <button title="Close" type="button" className="mfp-close" onClick={hideVideo}>
                                ×
                            </button>
                            <iframe
                                className="mfp-iframe"
                                src={`//www.youtube.com/embed/${video.id}?autoplay=1`}
                                frameBorder={0}
                                allow="autoplay"
                                allowFullScreen
                                title="Product video"
                            />
                        </div>
                    </div>
                    <div className="mfp-preloader">Loading...</div>
                </div>
            </div>
        </>
    );
};

export default VideoPopup;
